import { removeSessionInfo } from '@xolv-mybrightlink/common';
import { useCallback } from 'react';
import { useAuthContext } from './useAuth';

export const useClearAuth = () => {
  const [, dispatch] = useAuthContext();
  return useCallback(() => {
    removeSessionInfo();
    dispatch('UNAUTHENTICATED');
  }, [dispatch]);
};
